import axios from "./axyos";

export type OwnerReportDto = {
  id: string;
  reporterId?: string;
  reporterName?: string;
  reporterEmail?: string;
  reportedOwnerId?: string;
  reportedOwnerName?: string;
  adsId?: string;
  adTitle?: string;
  message: string;
  status?: string;
  createdAt?: string;
};

export const reportOwnerByAdApi = (adId: string, message: string) =>
  axios.post(`/ads/${encodeURIComponent(adId)}/report-owner`, { message });

export const listOwnerReportsForModerationApi = (limit = 120) =>
  axios.get<{ data?: OwnerReportDto[]; count?: number; status?: number }>("/reports/moderation", {
    params: { limit },
  });
